
const Posts = ({ attributes, clientId, firstPosts }) => {
    const { indicator, isLazyLoad } = attributes;

    return firstPosts?.map((slider, index) => {
        const { thumbnail } = slider || {};

        return <button key={index} type="button" data-bs-target={`#bsbCarousel-${clientId} .carousel`} data-bs-slide-to={index} className={`${index === 0 ? 'active' : ''}`} aria-current="true" aria-label={index}>
            {indicator?.type === 'image' && thumbnail?.url ? <>{isLazyLoad ? <img loading="lazy" data-src={thumbnail?.url} className="d-block w-100 lazyload" alt={thumbnail?.alt || thumbnail?.title} /> : <img src={thumbnail?.url} className="d-block w-100 " alt={thumbnail?.alt || thumbnail?.title} />} </> : ''}
        </button>
    })
}
export default Posts;